// Split article HTML after the Nth top-level paragraph so an inline block can be inserted.
// Returns [html] untouched when the article is shorter than `minParagraphs`.
export function splitHtmlAfterParagraph(html, after = 4, minParagraphs = 8) {
  if (!html || typeof window === "undefined") return [html || ""];
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, "text/html");
  const nodes = Array.from(doc.body.childNodes);
  const isPara = (n) => n.nodeName === "P" && (n.textContent || "").trim().length > 0;
  const total = nodes.filter(isPara).length;
  if (total < minParagraphs) return [html];
  let count = 0;
  let cut = -1;
  for (let i = 0; i < nodes.length; i++) {
    if (isPara(nodes[i]) && ++count === after) { cut = i + 1; break; }
  }
  if (cut < 0) return [html];
  const ser = (list) => list.map((n) => (n.nodeType === 1 ? n.outerHTML : n.textContent)).join("");
  return [ser(nodes.slice(0, cut)), ser(nodes.slice(cut))];
}
